var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "email_svg__a",
    width: 21,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.967 0h20v20h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#email_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6FB265",
    d: "M10.967 18.335a8.1 8.1 0 0 1-3.25-.657 8.4 8.4 0 0 1-2.646-1.78A8.4 8.4 0 0 1 3.29 13.25a8.1 8.1 0 0 1-.656-3.25q0-1.729.656-3.25a8.4 8.4 0 0 1 1.781-2.646 8.4 8.4 0 0 1 2.646-1.78 8.1 8.1 0 0 1 3.25-.657q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.781 2.646 8.1 8.1 0 0 1 .657 3.25v1.209q0 1.23-.844 2.093-.844.865-2.073.865-.73 0-1.375-.312a2.94 2.94 0 0 1-1.084-.896 4 4 0 0 1-1.364.906 4.3 4.3 0 0 1-1.594.302q-1.729 0-2.948-1.219Q6.8 11.731 6.8 10.001q0-1.728 1.22-2.948 1.218-1.218 2.947-1.218t2.948 1.218q1.22 1.22 1.219 2.948v1.209q0 .54.354.916.354.375.896.375.541 0 .896-.375.354-.375.354-.916V10q0-2.79-1.938-4.729-1.937-1.937-4.729-1.937T6.238 5.272Q4.3 7.21 4.3 10.002q0 2.79 1.938 4.728t4.73 1.938h4.166v1.667zm0-5.834q1.042 0 1.771-.729a2.4 2.4 0 0 0 .73-1.77 2.4 2.4 0 0 0-.73-1.772 2.4 2.4 0 0 0-1.77-.729 2.4 2.4 0 0 0-1.772.73A2.4 2.4 0 0 0 8.467 10q0 1.042.73 1.771.728.73 1.77.73"
  }))));
};
export default SvgEmail;